import { render } from "./DataMap.vue?vue&type=template&id=601e52c8"
import script from "./DataMap.vue?vue&type=script&lang=js"
export * from "./DataMap.vue?vue&type=script&lang=js"
script.render = render

export default script